module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"dk":{"inviteAssociate":"Inviter nyt medlem","noAccountsFound":"Der er ingen {roleLabel}-kontoer.","education":"Uddannelse","removeUser":"Fjern bruger","editUser":"Rediger bruger"}}')
  delete Component.options._Ctor
}
